
import createIconComponent from '../utils/createIconComponent';
import { SVG_ALERT_OUTLINED } from '../../../dist';
import React from 'react';
const AlertOutlinedIcon = createIconComponent({ content: SVG_ALERT_OUTLINED, height: 24, width: 24 });
AlertOutlinedIcon.displayName = 'AlertOutlinedIcon';
export default AlertOutlinedIcon;
